export default "__VITE_ASSET__79cb8058__"